var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-sidebar-promo"},_vm._l((_vm.items),function(item){return _c('SidebarPromoItem',_vm._b({key:item.id,attrs:{"selectedItemId":_vm.selectedItemId},on:{"click":_vm.onClick}},'SidebarPromoItem',item,false))}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e3a8f48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/shared/sidebar/SidebarPromoItems.vue
// module id = 1911
// module chunks = 0